import styled, { keyframes } from 'styled-components';

import { TLoadingDotsDotProps } from '@/shared/components/ui/loading-dots/loading-dots.types';

const blinkAnimation = keyframes`
  0%, 80%, 100% {
    opacity: 0.3;
    transform: scale(0.8);
  }
  40% {
    opacity: 1;
    transform: scale(1);
  }
`;

export const LoadingDotsContainer = styled.div`
  display: flex;
  gap: 0.25rem;
  align-items: center;
`;

export const Dot = styled.div<TLoadingDotsDotProps>`
  width: 0.5rem;
  height: 0.5rem;
  background-color: ${({ theme }) => theme.palette.primary.main};
  border-radius: 50%;
  animation: ${blinkAnimation} 1.4s infinite both;
  animation-delay: ${({ $delayInSeconds }) => `${$delayInSeconds || 0}s`};
`;
